<template>
  <transition name="fade">
    <div class="modal-backdrop d-flex justify-content-center align-items-center" v-if="isOpen">
      <div class="text-center" style="display: flex;flex-direction: column;align-items: center;">
        <img src="@/assets/pic/yumEat.png" width="100" class="mb-3" />
        <div class="spinner-border text-danger spanner-custom" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref } from 'vue'

const isOpen = ref(true) // مثال، تحكم بفتح وغلق اللودر
</script>

<style>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background-color: #fcfaf4;
  z-index: 1050; /* قيمة أعلى من الـ Bootstrap modal */
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.spanner-custom{
  color: #ef4c0c;
}
</style>
